import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import AdCard from 'components/AdCard';
import Pagination from 'components/Pagination';
import Promo from './Promo';
import { AD_TYPE_PROMO } from '../../../../constants';
import { AD_SEARCH_TRACK_AS } from '../../../constants';
import { SECONDARY_PROMO_VARIANT } from './constants';

import cn from './styles.local.less';

export default class AdList extends PureComponent {
  static propTypes = {
    isSearchLoading: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    loadPage: PropTypes.func,
    onToggleAdDislikeClick: PropTypes.func.isRequired,
    onToggleAdFavoriteClick: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    withMerchantInfo: PropTypes.bool,
  };

  static defaultProps = {
    withMerchantInfo: true,
  };

  render() {
    const {
      isSearchLoading,
      items,
      loadPage,
      pagination,
      withMerchantInfo,
      onToggleAdDislikeClick,
      onToggleAdFavoriteClick,
    } = this.props;

    return (
      <Fragment>
        <div
          className={cns({ [cn.fade]: isSearchLoading })}
          data-qa-selector="ad-list"
        >
          <ul className={cn.root}>
            {items.map((ad) => (
              <li
                key={ad.id}
                className={cns(cn.item, {
                  [cn.hideCardBanner]:
                    ad.type === AD_TYPE_PROMO &&
                    ad.variant === SECONDARY_PROMO_VARIANT,
                })}
              >
                {ad.type === AD_TYPE_PROMO ? (
                  <Promo {...ad} />
                ) : (
                  <AdCard
                    {...ad}
                    trackAs={AD_SEARCH_TRACK_AS}
                    withMerchantInfo={withMerchantInfo}
                    onToggleAdFavoriteClick={onToggleAdFavoriteClick}
                    onToggleAdDislikeClick={onToggleAdDislikeClick}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
        {pagination ? (
          <Pagination pagination={pagination} loadPage={loadPage} />
        ) : null}
      </Fragment>
    );
  }
}
